// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oeos-choices[data-v-2dba917a]{display:block}.oeos-choices .v-btn[data-v-2dba917a]{transition:background-color .25s ease;min-width:20px}", ""]);
// Exports
module.exports = exports;
